function isListLine(s) {
  return /^\s*[-*\u2022]\s+/.test(s) || /^\s*\d+\.\s+/.test(s);
}

function isStructuralLine(s) {
  const t = s.trim();
  if (!t) return false;
  return t.startsWith('#') || t.startsWith('|') || /^---+$/.test(t);
}

export function preprocessLines(lines) {
  // PASS 1: Drop blank lines that are mid-sentence breaks
  const pass1 = [];
  for (let i = 0; i < lines.length; i++) {
    const trimmed = lines[i].trim();
    if (trimmed === '') {
      let lastReal = -1;
      for (let k = pass1.length - 1; k >= 0; k--) {
        if (pass1[k].trim() !== '') { lastReal = k; break; }
      }
      let nextIdx = i + 1;
      while (nextIdx < lines.length && lines[nextIdx].trim() === '') nextIdx++;
      const nextLine = nextIdx < lines.length ? lines[nextIdx] : '';
      const nextTrimmed = nextLine.trim();

      if (lastReal >= 0 && nextTrimmed !== '') {
        const prevTrimmed = pass1[lastReal].trim();
        const prevIsStructural = isStructuralLine(pass1[lastReal]);
        const nextIsStructural = isStructuralLine(nextLine);
        const nextIsList = isListLine(nextLine);
        const prevIsList = isListLine(pass1[lastReal]);

        const prevEndsThought = /[.?!]\s*$/.test(prevTrimmed) || prevIsStructural;
        const nextStartsNew = nextIsStructural || nextIsList;

        if (!prevEndsThought && !nextStartsNew) continue;
        if (prevIsList && !nextIsStructural && !nextIsList) continue;
      }
    }
    pass1.push(lines[i]);
  }

  // PASS 2: Merge continuation lines onto the previous line
  const merged = [];
  for (let i = 0; i < pass1.length; i++) {
    const line = pass1[i];
    const trimmed = line.trim();

    if (merged.length > 0 && trimmed !== '') {
      const lastIdx = merged.length - 1;
      const prevLine = merged[lastIdx];
      const prevTrimmed = prevLine.trim();
      const prevIsStructural = isStructuralLine(prevLine);
      const prevIsList = isListLine(prevLine);

      const isPunct = trimmed === ',' || trimmed === '.' || trimmed === ';' || /^[,;.]\s/.test(trimmed);
      const isBulletCont = prevIsList && !isStructuralLine(line) && !isListLine(line);
      const prevEndsThought = /[.?!]\s*$/.test(prevTrimmed) || prevIsStructural || prevIsList;
      const thisStartsNew = isStructuralLine(line) || isListLine(line);
      const isParagraphCont = !prevEndsThought && !thisStartsNew;

      if (isPunct || isBulletCont || isParagraphCont) {
        merged[lastIdx] = prevLine.trimEnd() + ' ' + trimmed;
        continue;
      }
    }
    merged.push(line);
  }
  return merged;
}
